<template>
  <div id="app">
    <!-- remember always wrap whole app with v-app to include properly vuetify styles
      -->
    <v-app style="position: relative; overflow: hidden;">
      <notif-container />
      <transition name="page" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-app>
  </div>
</template>

<script>
import NotifContainer from "@/components/Notification/NotifContainer.vue";

export default {
  name: "App",
  components: {
    NotifContainer,
  },
};
</script>
<style>
@import "./assets/css/style.css";
@import "./assets/css/section_style.css";

.href {
  text-decoration: none;
}

/* Page routing transition — horizontal slide */
.page-enter-active,
.page-leave-active {
  transition: transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94),
              opacity 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: absolute;
  width: 100%;
}

.page-enter {
  transform: translateX(40px);
  opacity: 0;
}

.page-enter-to {
  transform: translateX(0);
  opacity: 1;
}

.page-leave {
  transform: translateX(0);
  opacity: 1;
}

.page-leave-to {
  transform: translateX(-40px);
  opacity: 0;
}
</style>
